export const getTimeElapsed = (timestamp: any) => {
  const now = Date.now();
  const diffInSeconds = Math.floor((now - timestamp) / 1000);

  // Define time intervals
  const intervals = [
    { label: "d", seconds: 86400 }, // 1 day = 24 hours * 60 minutes * 60 seconds
    { label: "h", seconds: 3600 }, // 1 hour = 60 minutes * 60 seconds
    { label: "m", seconds: 60 }, // 1 minute = 60 seconds
    { label: "s", seconds: 1 }, // 1 second
  ];

  // Find the appropriate time interval
  for (let i = 0; i < intervals.length; i++) {
    const interval = intervals[i];
    const intervalCount = Math.floor(diffInSeconds / interval.seconds);
    if (intervalCount > 0) {
      return `${intervalCount}${interval.label}`;
    }
  }

  return "now";
};
